const imgPath = {  
  user_head: require('@/assets/images/user_head.png'), // 用户头像
  teacher_head: require('@/assets/images/user_head.png'), // 用户头像

  yunzhi_code: require('@/assets/images/yunzhi_code.jpg'), // 联系我们二维码
  yunzhi_footer_logo: require('@/assets/footer-logo.png'), // 底部logo

  /* course */
  course_collect_no: require('@/assets/images/course_collect_no.png'), // 课程未收藏
  course_collect_yes: require('@/assets/images/course_collect_yes.png'), // 课程已收藏
  course_share: require('@/assets/images/course_share.png'), // 课程分享
  course_mode: require('@/assets/images/course_mode.png'), // 教学模式
  course_date: require('@/assets/images/course_date.png'), // 课程有效期
  course_study_num: require('@/assets/images/course_study_num.png'), // 课程学习人数
  course_peope_count: require('@/assets/images/course_peope_count.png'), // 课程学习人数
  course_study_yes: require('@/assets/images/course_study_yes.png'), // 课程已学习
  course_study_no: require('@/assets/images/course_study_no.png'), // 课程未学习

  /* pay */
  pay_success: require('@/assets/images/pay_success.png'), // 下单成功
  pay_wx: require('@/assets/images/pay_wx.png'), // wx
  pay_ali: require('@/assets/images/pay_ali.png'), // ali
  pay_wx_tip: require('@/assets/images/pay_wx_tip.png'), // wx_tip
  pay_status: require('@/assets/images/pay_status.png'), // status
  pay_scan: require('@/assets/images/pay_scan.png'), // 扫描
  

  /* mine */
  mine_course_no: require('@/assets/images/mine_course_no.png'), // 我的课程未选中
  mine_special_no: require('@/assets/images/mine_special_no.png'), //专题课程未选中
  mine_collect_no: require('@/assets/images/mine_collect_no.png'), //我的收藏未选中
  mine_order_no: require('@/assets/images/mine_order_no.png'), //我的订单未选中
  mine_personal_no: require('@/assets/images/mine_personal_no.png'), //个人资料未选中
  mine_password_no: require('@/assets/images/mine_password_no.png'), //修改密码未选中

  mine_course_yes: require('@/assets/images/mine_course_yes.png'), // 我的课程选中
  mine_special_yes: require('@/assets/images/mine_special_yes.png'), //专题课程选中
  mine_collect_yes: require('@/assets/images/mine_collect_yes.png'), //我的收藏选中
  mine_order_yes: require('@/assets/images/mine_order_yes.png'), //我的订单选中
  mine_personal_yes: require('@/assets/images/mine_personal_yes.png'), //个人资料选中
  mine_password_yes: require('@/assets/images/mine_password_yes.png'), //修改密码选中

  /* home */
  home_count: require('@/assets/images/home_counter.png'), // 首页课程人数
  home_recommend: require('@/assets/images/home_recommend.png'), // 首页推荐课程
}
export default imgPath